import { withErrorBoundary } from 'app/components/error-boundary';
import { OnboardingLayout } from 'app/components/onboarding/layout';
import { ChooseSharerTypeOptions } from 'app/screens/onboarding/choose-sharer-type.shared';
import { useChooseSharerTypeFlow } from 'app/screens/onboarding/hooks/use-choose-sharer-type-flow';
import { useOnboardingNavigation } from 'app/screens/onboarding/credentials';
import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle } from 'app/utils/web-helpers';
import React, { useEffect } from 'react';

const ChooseSharerTypeScreenComponent: NavigationScreen<'choose-sharer-type'> = ({ navigation }) => {
  const flow = useChooseSharerTypeFlow(navigation);

  const setPageTitle = usePageTitle('choose-sharer-type');
  useEffect(() => setPageTitle('title'), [setPageTitle]);

  const { progressActiveColor } = useOnboardingNavigation(flow.userInfo?.type, { headerPresentation: 'solid' });

  const primaryProps = {
    disabled: !flow.isSharerTypeSelected,
    loading: flow.isPending,
    onPress: () => {
      void flow.saveSharerTypePreferences();
    },
  };

  const showProgress = !Boolean(flow.userInfo?.acceptedGuidelineDate);

  return (
    <OnboardingLayout activeColor={progressActiveColor} primary={primaryProps} showProgress={showProgress}>
      <ChooseSharerTypeOptions
        gap="spacing.general.x4"
        selectedSharerType={flow.selectedSharerType}
        onSelect={flow.onSelect}
      />
    </OnboardingLayout>
  );
};

export const ChooseSharerTypeScreen: NavigationScreen<'choose-sharer-type'> = withErrorBoundary(
  ChooseSharerTypeScreenComponent,
);
